import React from "react";

const HowOlaplexImpact = () => {
  return (
    <div className="blogHead-content">
      <h2>The Impact of Coloring on Hair Health</h2>
      <p>
        Coloring your hair, especially with bleach or permanent dyes, can cause
        significant damage. The chemicals used in these products break down the
        hair’s natural structure to deposit color, which can lead to weakened
        hair bonds, dryness, and frizz. Over time, repeated coloring can result
        in dull, lifeless hair that is prone to breakage.
      </p>
      <p>
        This is where Olaplex steps in as a savior. Unlike traditional
        conditioners or masks that only coat the surface of the hair, Olaplex
        works at the molecular level to restore and strengthen the hair from
        within.
      </p>
    </div>
  );
};

export default HowOlaplexImpact;
